module.exports = __webpack_public_path__ + "img/img-83.7c84d363.png";